import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
import InstrumentComponent from './InstrumentComponent';
import styles from './InstrumentList.less';
import config from './../../config';
import i18next from 'i18next';
import { applyStyleapplyToHover, setDirection } from './../../utils/utils';
import HoverTable from './../../components/HoverTable/index.js';
// const elementsData = [
//   {"classNames":"widgetheader","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"vericalDotIcon","elementType":"normal", "applyTo":"alternative", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"widgettitle","elementType":"normal", "applyTo":"alternative", "tagNames":"div"},
//   {"classNames":"listRow","elementType":"normal", "applyTo":"alternative", "tagNames":"div"},
//   {"classNames":"instLstHead","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"instLstTblHead","elementType":"normal", "applyTo":"all", "tagNames":"th"},
//   {"classNames":"instLstTd","elementType":"normal", "applyTo":"all", "tagNames":"td"},
//   {"classNames":"instBg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];
const directionData = [
  {"classNames":"widgettitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"vericalDotIcon","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetBody","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];
  @connect(
  state => ({
    socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
    dashboardWidgets: state.dashboardRoot.dashboardReducer.dashboardWidgets,
    deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
	  openedWidgets: state.dashboardRoot.commonReducer.openedWidgets,
    socketData : state.dashboardRoot.instrumentListReducer.socketData,
    userDetail: state.auth.userDetail,
    layout: state.dashboardRoot.dashboardReducer.layout,
    // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    fontSize: state.auth.userDetail.fontSize,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language
  }),
  { ...instrumentListActions, ...dashboardActions, ...tradepanelActions, ...commonActions, ...authActions})

export default class InstrumentListComponent extends Component {
  static propTypes = {
    socketDataStatic: PropTypes.array,
    CloseIcon: PropTypes.object,
    keyValue: PropTypes.string.isRequired,
    deleteWidget: PropTypes.func,
    showPreview: PropTypes.object,
    popoutIcon: PropTypes.object,
    popupwindowHandle: PropTypes.func,
    closeSocketData: PropTypes.func,
    loadSocketData: PropTypes.func,
    openedWidgets: PropTypes.array,
    popinWidget: PropTypes.func,
    fontsize:PropTypes.string,
    userDetail:PropTypes.object,
    deleteWidgetKey: PropTypes.array,
    layoutChanged: PropTypes.func,
    changeWidgetlayout: PropTypes.func,
    resizeInstrumentList: PropTypes.func,
  }
  state = {
    clickedRemove: false,
    deleteWidget:[],
    showGridOptions:false,
  }
  closeWidget = (keyValue) => {
    try{
      this.setState({ clickedRemove: true });
      this.props.deleteWidget(keyValue);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"InstrumentListComponent"});
    }
  }
  gridType = () => {
    try{
      this.setState({showGridOptions: !this.state.showGridOptions});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'gridType', component:"InstrumentListComponent"});
    }
  }
  closeGridType = () => {
    try{
      this.setState({showGridOptions: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeGridType', component:"InstrumentListComponent"});
    }
  }
  onClick = (e, data) => {
    try{
      this.props.resizeInstrumentList(data.rowNumber+1,data.columnNumber+1);
      this.setState({showGridOptions: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClick', component:"LayoutComponent"});
    }
  }
  componentDidMount(){
    this.setState({deleteWidget: this.props.deleteWidgetKey});
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }
  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
   // //const allCssStyleRules = this.props.selectedCssColorTheme;
   // applyStyle(thisComponent, allCssStyleRules, elementsData);
   }
  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
    //     {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if(this.state.deleteWidget !== nextProps.deleteWidgetKey){
        this.setState({clickedRemove: false});
        this.setState({deleteWidget: nextProps.deleteWidgetKey});
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
  }
  render() {
    const { showPreview, CloseIcon, keyValue, popoutIcon,fontsize} = this.props;
    const url = document.URL;
    const splitURL = url.toString().split('/');
    // const detailedInstList=JSON.parse(localStorage.getItem('TS')).isDetailedInstList;
    const closeIconImg= <img width="16px" src="/images/close.png"/>;
    const selectedfont_size='fontSize_'+this.props.userDetail.fontSize;
    return (
      <div id="instWidgetMain" className={`${styles.instrumentListWidget} `}>{!this.state.clickedRemove ?
        <div className={`${styles.instrumentList} instBg`}>
          <div className='headerInner'>
            <div className="widgetheader">
              <span className={`${selectedfont_size} ${styles.widgettitle}`}>{i18next.t('instrumntList')}</span>
              <span onClick={() => this.gridType()}  className="vericalDotIcon"></span>
              {/* this.state.showGridOptions === true ?
              <div className={`${selectedfont_size} gridOptions`}>
                <div className={`gridOptionsWrapper`}>
                  <span>{i18next.t("Resize")}</span>
                </div>
              </div> : null
              */}
              <div className={`resizeLayout`}>
                <HoverTable
                column={5}
                row={5}
                width={110}
                height={110}
                selectedRow={this.props.height-1}
                selectedColumn={this.props.width-1}
                onClick={this.onClick}
                showDimension={true} // show dimension or not
                onMouseOut={this.onMouseOut}
                onMouseOver={this.onMouseOver}
                theme="light"
                defaultColumn={0}
                defaultRow={0}
                />
              </div>
              <span onClick={() => this.closeWidget(keyValue)}>{CloseIcon}</span>
              {/* <span style={font} onClick={() => this.popoutWidget('http://' + splitURL[2] + '/instrument_list?id=' +encrypted, keyValue)} className={this.state.isPopOutDisabled === false ?`${styles.icon} popupicon` : `${styles.icon} ${styles.disabled} popupicon`}><img src="/images/popout.png" /></span> */}
            </div>
          </div>
          <div className={`${styles.widgetBody} ${selectedfont_size} widgetBody ${this.props.language}`} onClick={() => this.closeGridType()}>
            <div className={`${styles.tableFixHead} tableFixHead`}>
              <table id="instListTbl">
                <thead>
                  <tr>
                    <th className={`${selectedfont_size} instLstTblHead`}>{i18next.t('cmdtyPair')}</th>
                    <th className={`${selectedfont_size} instLstTblHead`}>{this.props.userDetail.ShowBuySellInRates === true ? i18next.t("sell"):i18next.t('bid')}</th>
                    <th className={`${selectedfont_size} instLstTblHead`}>{this.props.userDetail.ShowBuySellInRates === true ? i18next.t("buy"):i18next.t('ask')}</th>
                    {this.props.width > 1 ?
                    <th className={`${selectedfont_size} instLstTblHead`}>{i18next.t('high')}</th>
                    :null}
                    {this.props.width > 1 ?
                    <th className={`${selectedfont_size} instLstTblHead`}>{i18next.t('low')}</th>
                    :null}
                  </tr>
                </thead>
                <tbody>
                  {this.props.socketDataStatic.map((item, index) => {
                    return(
                    <InstrumentComponent cmdtyrow={item} index={index} width={this.props.width} height={this.props.height}/>
                    );
                  }) }
                </tbody>
              </table>
            </div>
          </div>
        </div>:null}
      </div>
    )
  }
}
